<template>
  <div>
    login
  </div>
</template>

<script>
  import config from '../../configs'
  export default {
    name: 'login',
    beforeRouteEnter () {
      let originUrl = `${config.HOST}/&toolsId=${config.TOOLS_ID}`;
      location.replace(config.MASTER_WEB_URL + '/public-login?oauth_callback=' + originUrl)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// login.vue?72a2ca90